// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Nrae7","text":"Header_text__EDLzX","img":"Header_img__UwJbO"};